import React, { Component } from 'react';
import { Tabs, Tab, Grid, Row, Col, FormGroup, ControlLabel, FormControl, Table, Panel, ButtonToolbar, Button } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";
import { PropTypes } from 'prop-types';

import { HandleMessage } from '../../../HandleMessage';
import { TitleRow } from '../../../TitleRow';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { LinesCommand } from '../../commands/LinesCommand';
import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { SchedulesCommand } from '../../commands/SchedulesCommand';
import { DrawCommand } from '../../commands/DrawCommand';

export class SmtucScheduleGenerator extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    constructor(props) {
        super(props);

        const availableLayouts = [
            { id: 1, name: "Horário de Linha" },
            { id: 2, name: "Horário de Bolso" }
        ];

        this.state = {
            edition: undefined,
            dependencies: {
                lines: [],
                schedules: [],
                setOfDayTypes: []
            },
            form: {
                layout: availableLayouts[0],
                line: undefined,
                complementaryLines: [],
                referenceDate: new Date().toISOString(),
                sets: {},
            },
            render: {
                tab: 1,
                layouts: availableLayouts,
                schedules: []
            },
            sort: {
                column: "code",
                order: "ascending",
            },
            commands: {
                lines: new LinesCommand(),
                setOfDayTypes: new SetOfDayTypesCommand(),
                schedules: new SchedulesCommand(),
                draw: new DrawCommand()
            },
            actions: {
                isLoadingEdition: true,
                isLoadingLines: true,
                isLoadingSchedules: true,
                isLoadingSetOfDayTypes: true,
                isGenerating: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);
        this.getSetOfDayTypes();

        const edition = this.context.getOwnEdition();
        edition.addObserver(this);

        this.setState({
            edition: edition
        });
    }

    componentWillUnmount() {
        this.state.edition.removeObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        const { actions, form } = this.state;

        actions.isLoadingLines = true;
        form.line = undefined;

        this.setState({
            form: form,
            actions: actions
        }, () => {
            this.getLines(this.state.edition);
            this.onChangeLineSelected();
        });
    }

    updatePlanning() {
        const { actions, render } = this.state;

        actions.isLoadingSchedules = true;
        render.schedules = [];

        this.setState({
            actions: actions,
            render: render
        }, () => {
            this.getSchedules(this.state.edition);
        });
    }

    // ----------------------

    getLines(edition) {
        const { actions, commands } = this.state;
        commands.lines.list(
            edition.network,
            (a) => this.listSuccessCallback(a, "lines", "isLoadingLines"),
            (a) => this.listErrorCallback(a, "lines", "isLoadingLines")
        );

        actions.isLoadingLines = true;

        this.setState({
            actions: actions
        });
    }

    getSetOfDayTypes() {
        const { actions, commands } = this.state;

        commands.setOfDayTypes.listFull(
            (a) => this.listSuccessCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes"),
            (a) => this.listErrorCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes")
        );

        actions.isLoadingSetOfDayTypes = true;

        this.setState({
            actions: actions
        });
    }

    getSchedules(edition) {
        const { actions, commands } = this.state;

        commands.schedules.list(
            edition.planning,
            (a) => this.listSuccessCallback(a, "schedules", "isLoadingSchedules", () => this.filterSchedules()),
            (a) => this.listErrorCallback(a, "schedules", "isLoadingSchedules")
        );

        actions.isLoadingSchedules = true;

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, action, callback = undefined) {
        const { dependencies, actions } = this.state;

        actions[action] = false;
        dependencies[dataType] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, action) {
        const { dependencies, actions, message } = this.state;

        actions[action] = false;
        dependencies[dataType] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    generationSuccessCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    generationErrorCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    onChangeSort(column) {
        const { sort } = this.state;

        if (sort.column === column) {
            sort.order = sort.order === "ascending" ? "descending" : "ascending";
        } else {
            sort.column = column;
            sort.order = "ascending";
        }

        this.setState({
            sort: sort
        });
    }

    onSelectValue(e, property, callback = undefined) {
        const { form } = this.state;

        form[property] = e;

        this.setState({
            form: form
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    onChangeReferenceDateValue(date) {
        const { form } = this.state;

        form.referenceDate = date;

        this.setState({
            form: form,
        }, () => {
            const { edition } = this.state;
            edition.update(new Date(date));
        });
    }

    onSelectAllSchedules(set, setOfDayTypesSchedules) {
        const { form } = this.state;
        const setOfDayTypesSchedulesIds = setOfDayTypesSchedules.map(setSchedule => setSchedule.id);

        if (undefined === form.sets[set] || !setOfDayTypesSchedulesIds.every(setScheduleId => form.sets[set].schedules.includes(setScheduleId))) {
            form.sets[set] = {
                order: -1,
                heightRatio: 1,
                schedules: setOfDayTypesSchedulesIds.map(scheduleId => scheduleId)
            };
        }
        else {
            form.sets[set].schedules = form.sets[set].schedules
                .filter(schedule => !setOfDayTypesSchedulesIds.includes(schedule));
        }

        this.setState({
            form: form
        }, () => {
            this.sortFormSets();
        });
    }

    onScheduleRowClick(set, schedule) {
        const { form } = this.state;

        if (undefined === form.sets[set]) {
            form.sets[set] = {
                order: -1,
                heightRatio: 1,
                schedules: [schedule]
            };
        }
        else if (form.sets[set].schedules.includes(schedule)) {
            form.sets[set].schedules = form.sets[set].schedules
                .filter(setSchedule => setSchedule !== schedule);
        }
        else {
            form.sets[set].schedules.push(schedule);
        }

        this.setState({
            form: form
        }, () => {
            this.sortFormSets();
        });
    }

    onGenerateClick() {
        const { form } = this.state;

        if (undefined === form.layout || null === form.layout) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar um layout.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        if (undefined === form.line || null === form.line) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar uma linha.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        if (0 === form.sets.length || Object.keys(form.sets).every(setKey => 0 === form.sets[setKey].schedules.length)) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar pelo menos um horário.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        const { actions, commands } = this.state;
        const data = {
            lineId: form.line.id,
            complementaryLinesIds: Array.isArray(form.complementaryLines) ? form.complementaryLines.map(line => line.id) : [],
            referenceDate: form.referenceDate,
            sets: form.sets
        };

        actions.isGenerating = true;

        switch (form.layout.id) {
            case 1:
                commands.draw.generateSmtucLineSched(
                    data,
                    (a) => this.generationSuccessCallback(a),
                    (a) => this.generationErrorCallback(a)
                );
                break;

            case 2:
                commands.draw.generateSmtucPocketSched(
                    data,
                    (a) => this.generationSuccessCallback(a),
                    (a) => this.generationErrorCallback(a)
                );
                break;

            default:
                actions.isGenerating = false;
                this.setState({
                    message: {
                        show: true,
                        title: "Aviso",
                        message: "Layout selecionado inválido.",
                        style: "warning",
                        icon: "alert"
                    }
                });
        }

        this.setState({
            actions: actions
        });
    }

    onChangeSetHeightRatioValue(e, set) {
        const { form } = this.state;

        if (undefined === form.sets[set]) {
            form.sets[set] = {
                order: -1,
                heightRatio: e.target.value,
                schedules: []
            };
        }
        else {
            form.sets[set].heightRatio = e.target.value;
        }

        this.setState({
            form: form
        }, () => {
            this.sortFormSets();
        });
    }

    onChangeLineSelected() {
        const { form } = this.state;

        if (undefined === form.line || null === form.line) {
            form.sets = {};
        }
        else {
            this.filterSchedules();
        }

        this.setState({
            form: form
        });
    }

    onTabSelected(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ----------------------

    onDragOver(e) {
        e.preventDefault();
    }

    onDragStart(e, idx) {
        e.dataTransfer.setData('index', idx);
    }

    onDrop(e) {
        const oldIndex = e.dataTransfer.getData('index');
        const newIndex = e.target.dataset.value;

        if (undefined !== oldIndex && undefined !== newIndex && oldIndex !== newIndex) {
            const { dependencies } = this.state;

            const oldIndexValue = dependencies.setOfDayTypes[oldIndex];

            dependencies.setOfDayTypes.splice(oldIndex, 1);
            dependencies.setOfDayTypes.splice(newIndex, 0, oldIndexValue);

            this.setState({
                dependencies: dependencies
            }, () => {
                this.sortFormSets();
            });
        }
    }

    // ----------------------

    sort(first, second) {
        const { sort } = this.state;

        var a = (first)[sort.column];
        var b = (second)[sort.column];

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            if (sort.order === "ascending") {
                return 1;
            } else {
                return -1;
            }
        } else if (b === undefined) {
            if (sort.order === "ascending") {
                return -1;
            } else {
                return 1;
            }
        }

        if (sort.order === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }
        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }

    sortFormSets() {
        const { dependencies, form } = this.state;

        form.sets = dependencies.setOfDayTypes
            .reduce((output, set) => {
                if (undefined !== output.sets[set.id]) {
                    output.sets[set.id].order = output.order++;
                }

                return output;
            }, { sets: form.sets, order: 0 })
            .sets;

        this.setState({
            form: form
        });
    }

    filterSchedules() {
        const { form, dependencies, render } = this.state;

        if (undefined === form.line) {
            render.schedules = [];
        }
        else {
            const complementaryLinesIds = Array.isArray(form.complementaryLines) ? form.complementaryLines.map(line => line.id) : [];
            render.schedules = dependencies.schedules
                .filter(schedule => Array.isArray(schedule.lines) && (schedule.lines.includes(form.line.id) || schedule.lines.some(scheduleLine => complementaryLinesIds.includes(scheduleLine))));
        }
        form.sets = {};

        this.setState({
            render: render,
            form: form
        });
    }

    // ----------------------

    renderEditionLoadingFeedback(isLoadingEdition) {
        return (
            <HandleMessage
                title="A Carregar a Edição..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isLoadingEdition}
                small
                noButtons />
        );
    }

    renderGeneratingFeedback(isGenerating) {
        return (
            <HandleMessage
                title="A Gerar..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isGenerating}
                small
                noButtons />
        );
    }

    renderForm() {
        const { dependencies, render, form } = this.state;

        return (
            <Grid className="margin-top-15" fluid>
                <FormGroup controlId="formLine">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Layout</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Layout selecionado"
                                noOptionsMessage={() => "Sem Layouts Configurados"}
                                onChange={(e) => this.onSelectValue(e, "layout")}
                                options={render.layouts}
                                isMulti={false}
                                isClearable={false}
                                isOptionSelected={function (a) {
                                    return form.layout.id === a.id;
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={form.layout}
                            />
                        </Col>
                    </Row>

                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Linha Principal</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linha selecionada"
                                noOptionsMessage={() => "Sem Linhas Configuradas"}
                                onChange={(e) => this.onSelectValue(e, "line", (a) => { this.onChangeLineSelected(a); })}
                                options={dependencies.lines}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    return form.line === a.id;
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => `${label.code} | ${label.goName}`}
                                value={form.line}
                            />
                        </Col>
                    </Row>

                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Linhas Complementares</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linhas complementares selecionadas"
                                noOptionsMessage={() => "Sem Linhas Configuradas"}
                                onChange={(e) => this.onSelectValue(e, "complementaryLines", (a) => { this.onChangeLineSelected(a); })}
                                options={dependencies.lines.filter(line => line !== form.line)}
                                isMulti={true}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    return form.complementaryLines.includes(a);
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => `${label.code} | ${label.goName}`}
                                value={form.complementaryLines}
                            />
                        </Col>
                    </Row>

                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <DatePicker
                                id="referenceDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.referenceDate}
                                placeholder="Data de Referência"
                                onChange={(e) => this.onChangeReferenceDateValue(e)} />
                        </Col>
                    </Row>
                </FormGroup>
            </Grid>
        );
    }

    renderSetOfDayTypesRow(edition, schedules, form, setOfDayTypes, idx) {
        const setOfDayTypesSchedules = schedules.filter(schedule => setOfDayTypes.id === schedule.setOfDayTypes.id);
        if (0 === setOfDayTypesSchedules.length) {
            return null;
        }

        return (
            <Grid key={`day-type-schedules-${idx}`}
                fluid
                draggable={true}
                onDragOver={(a) => this.onDragOver(a)}
                onDragStart={(a) => this.onDragStart(a, idx)}>
                <Row data-value={idx}>
                    <Col sm={3} md={2} data-value={idx}>
                        <div className="margin-top-15 padding-top-7 control-label" data-value={idx}>
                            {setOfDayTypes.name}
                        </div>
                    </Col>
                    <Col sm={9} md={10} className="table-small-screens" data-value={idx}>
                        <Table responsive data-value={idx}>
                            <thead>
                                <tr>
                                    <th className="width-70p" data-value={idx}>Nome</th>
                                    <th className="width-30p" data-value={idx}>Edição</th>
                                    <th data-value={idx}><Button bsSize="small" bsStyle="link" className="pull-right" onClick={() => this.onSelectAllSchedules(setOfDayTypes.id, setOfDayTypesSchedules)}>SELECIONAR TUDO</Button></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    setOfDayTypesSchedules.map((schedule, index) =>
                                        <tr key={`sched-${index}`}
                                            className={`busched selectable ${undefined !== form.sets[setOfDayTypes.id] && form.sets[setOfDayTypes.id].schedules.includes(schedule.id) ? "checked" : ""}`}
                                            onClick={() => this.onScheduleRowClick(setOfDayTypes.id, schedule.id)}>
                                            <td data-value={idx}>{schedule.name}</td>
                                            <td colSpan={2} data-value={idx}>{edition.getPlanningEditionName(schedule.planningEdition)}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>

                <Row>
                    <Col sm={3} md={2}>
                        <ControlLabel className="padding-top-7">Altura (Proporção)</ControlLabel>
                    </Col>
                    <Col sm={9} md={10}>
                        <FormControl type="number"
                            defaultValue={1}
                            min={1}
                            onChange={(e) => this.onChangeSetHeightRatioValue(e, setOfDayTypes.id)} />
                    </Col>
                </Row>

                <Row className="height-30px">
                    <Col>
                        <hr className="morgin-bottom-0" />
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderSchedulesTab(isLoadingSchedules) {
        if (isLoadingSchedules) {
            return <LoadingSpinner />
        }

        const { render, form } = this.state;

        if (0 === render.schedules.length) {
            return (
                <Panel key="noSchedules" className="margin-top-15">
                    <Panel.Heading>
                        <Panel.Title>Atenção</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>Não existem horários associados à linha selecionada.</Panel.Body>
                </Panel>
            );
        }

        const { edition, dependencies } = this.state;

        return (
            <div onDrop={(a) => this.onDrop(a)}>
                {dependencies.setOfDayTypes.map((setOfDayTypes, idx) => this.renderSetOfDayTypesRow(edition, render.schedules, form, setOfDayTypes, idx))}
            </div>
        );
    }

    renderBody() {
        const { form } = this.state;

        if (undefined === form.line || null === form.line) {
            return null;
        }

        const { render, actions } = this.state;

        return (
            <Tabs id="bussched_tabs" activeKey={render.tab} onSelect={(a) => this.onTabSelected(a)}>
                <Tab eventKey={1} key="sched" title="Horários">
                    {this.renderSchedulesTab(actions.isLoadingSchedules)}
                </Tab>
            </Tabs>
        );
    }

    renderContent(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return (
            <Grid fluid>
                {this.renderForm()}
                {this.renderBody()}
            </Grid>
        );
    }

    render() {
        const { actions, message } = this.state;

        return (
            <div>
                <TitleRow title="Gerar Horário" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button onClick={() => this.onGenerateClick()}>GERAR</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                {this.renderContent(actions.isLoadingLines || actions.isLoadingSetOfDayTypes)}
                {this.renderGeneratingFeedback(actions.isGenerating)}
                {this.renderEditionLoadingFeedback(actions.isLoadingEdition)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/smtuc/SmtucScheduleGenerator.js